import React, { useMemo, useState, useContext, useEffect } from 'react'
import TableShipmentCharges from './tableShipmentCharges'
import '../../pages/GO/go.css'
import TableEquipments from './tableEquipments'
import TableBookingEquipments from './tableBookingEquipments'
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import GroupIcon from '@mui/icons-material/Group'
import { useMediaQuery, Popover, IconButton, MenuItem, ListItemText, Divider} from '@mui/material'
import { M_TextArea, M_Table, M_ElementDrawer, M_TimeLine, M_Button, M_MessageBoard, M_CheckBox, M_Select, M_InputTextField, M_DrawerTableTextField, M_Fieldset, M_Header, M_FormFavorites, useFavorites, BufferService, NavigateContext } from 'src/M_Components'
import { AirlineStopsOutlined, Anchor, Delete, RequestQuote, RequestQuoteOutlined, Star  } from '@mui/icons-material';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';

function GroupFavoriteActions({ groupName, t }) {
    const favCtx = useFavorites();
    const [anchorEl, setAnchorEl] = useState(null);
    const [name, setName] = useState('');

    if (!favCtx) return null;

    const { saveGroupFavorite, getGroupFavorites, handleApplyFavorite, handleDeleteFavorite } = favCtx;
    const groupFavs = getGroupFavorites(groupName);

    return (
        <div style={{ position: 'absolute', top: '10px', right: '18px', zIndex: 10 }}>
            <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Star sx={{ color: groupFavs.length > 0 ? 'var(--color-yellow, #f9a825)' : '#ccc', fontSize: '20px' }} />
            </IconButton>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => { setAnchorEl(null); setName(''); }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div style={{ minWidth: '250px' }}>
                    <div style={{ padding: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <M_InputTextField
                            size="small"
                            label={t('FavoriteName') || 'Name'}
                            value={name}
                            onChange={e => setName(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' && name.trim()) {
                                    saveGroupFavorite(groupName, name);
                                    setName('');
                                }
                            }}
                            autoFocus
                            fullWidth
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Save') || 'Save'}
                            backgroundColor={'var(--color-blue)'}
                            labelColor="var(--color-white)"
                            onClick={() => {
                                if (name.trim()) {
                                    saveGroupFavorite(groupName, name);
                                    setName('');
                                }
                            }}
                        />
                    </div>
                    {groupFavs.length > 0 && <Divider />}
                    {groupFavs.map(fav => (
                        <MenuItem
                            key={fav.Id}
                            onClick={() => { handleApplyFavorite(fav); setAnchorEl(null); }}
                            sx={{
                                '& .fav-delete': { opacity: 0, transition: 'opacity 0.2s' },
                                '&:hover .fav-delete': { opacity: 1 }
                            }}
                        >
                            <ListItemText>{fav.Description}</ListItemText>
                            <IconButton
                                className="fav-delete"
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleDeleteFavorite(fav.Id, e); }}
                                sx={{ marginLeft: '8px' }}
                            >
                                <Delete fontSize="small" sx={{ color: 'var(--color-red, #d32f2f)' }} />
                            </IconButton>
                        </MenuItem>
                    ))}
                </div>
            </Popover>
        </div>
    );
}

export default function SimpleCreateBooking({
    valueTimeline, voyage, entities, addShipment, addBookingEquipments, submitForApproval, voyageDict, setVoyageDict,
    entitiesDict, portsLocations, locationsDict, addValue, t, setEntitiesDict,
    extraValues, setExtraValues, bookingEquipments, bookingEquipmentDict, bookingEquipmentArray, setBookingEquipmentArray, setBookingEquipmentDict,
    equipments, equipmentDict, setEquipmentDict, shipmentArray,
    shipmentObjArray, setShipmentObjArray, setShipmentArray, onFillFields, shipmentIndex,
    setShipmentIndex, containerIndex, setContainerIndex, openDrawer, setOpenDrawer, selectedLine,
    setSelectedLine, openConfirmModal, handleCloseConfirmModal, openConfirmationModal, confirmationModal,
    submitedApproval, toJSONLocal, reformatDate, setLocationsDict, setEquipmentClass,
    toastMessages, summary, companies, getAccountCompany, setSaveAs, changedList, saveAs, EquipmentIndex, setEquipmentIndex,
    drawerName, setDrawerName, bookingLine, draft, id, ctx, operation, leavingPage, setLeavingPage,
    functionLeavingPage, fieldsInDrawerShipment, fieldsInDrawerEquipment, errorList,
    openEquipmentDrawer, setOpenEquipmentDrawer, confirmMovement,
    setConfirmMovement, open, setOpen, continueBooking,
    openDrawerSplitShipments, getLineBooking, onSaveMove, entitiesVarNameDict, setEntitiesVarNameDict,
    portsVarNameDict, setPortsVarNameDict, setLinkedQuote, shipmentChargesArray = [],
    showChangeQuoteModal = false, confirmChangeQuote, cancelChangeQuote,
    isAdmin = false, onRefreshCharges,
    adminDict = new Map(), setAdminDict,
    processDetailsDict = new Map(), setProcessDetailsDict,
}) {

    const matches = useMediaQuery('(min-width:1600px)')
    const [OpenModalSeeErrors, setOpenModalSeeErrors] = useState(false)
    const containerEquipmentTypeService = new BufferService('EquipmentType', 'secondary');
    const ctx2 = useContext(NavigateContext)

    const availableShipments = useMemo(() => {
        const seen = new Set()
        return (shipmentObjArray || [])
            .filter(eq => eq.ShipmentId && !seen.has(eq.ShipmentId) && seen.add(eq.ShipmentId))
            .map(eq => ({ ShipmentId: eq.ShipmentId, TransportKey: eq.Shipment }))
    }, [shipmentObjArray])


    const handleOpenCreate = (shipmentId) => {
        ctx.passValue.set('operation', 'create')
        ctx.passValue.set('sourceTabUrl', 'createBooking')
        ctx.passValue.set('Row', {
            BookingId: extraValues?.get('id'),
            BookingNumber: extraValues?.get('BookingNumber'),
            ShipmentId: shipmentId,
        })
        ctx2.newTab('go/shipmentChargesDetail', t('CreateShipmentCharge'))
    }

    const handleOpenEdit = (row) => {
        ctx.passValue.set('operation', 'edit')
        ctx.passValue.set('sourceTabUrl', 'createBooking')
        ctx.passValue.set('Row', row)
        ctx2.newTab('go/shipmentChargesDetail', t('EditShipmentCharge'))
    }

    return (
        <div style={{}}>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        {(operation === 'Edit') && errorList.ErrorMessage ? (
                            <M_Button
                                tooltip={t("SeeErrors")}
                                label={t("SeeErrors")}
                                icon={<i className="pi pi-info iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                onClick={() => setOpenModalSeeErrors(true)}
                            />
                        ) : null}
                        <M_Button
                            label={t("LabelSaveAsDraft")}
                            icon={<img src='/icons/svgsDaNet/archive.svg' style={{ width: '20px' }} className='iconTable' alt='SaveAsDraft' />}
                            tooltip={t("LabelSaveAsDraft")}
                            onClick={() => {
                                submitForApproval()
                                setSaveAs('Draft')
                            }}
                        />
                        <M_Button
                            label={t("LabelSubmitForApproval")}
                            icon={<img src='/icons/svgsDaNet/save.svg' style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '20px' }} alt='Submit for approval' />}
                            tooltip={t("LabelSubmitForApproval")}
                            onClick={() => {
                                submitForApproval()
                                setSaveAs('Waiting')
                            }}
                        />
                        <M_Button
                            label={t("LabelSplitToDraft")}
                            icon={<AirlineStopsIcon style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} />}
                            tooltip={t("LabelSplitToDraft")}
                            onClick={() => {
                                openDrawerSplitShipments()
                            }}
                        />
                        <M_Button
                            entity={'quote'}
                            FILTER={"StatusValue eq 'A'"}
                            tooltip={t("LinkWithQuote")}
                            label={t("LinkWithQuote")}
                            icon={<RequestQuoteOutlined style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }} />}
                            onGetline={setLinkedQuote}
                            key={'linkQuoteBooking'}
                            tableLabel={'Approved Quotes'}
                        />
                    </>
                }
            />
            <div className='principalDivTimeline'>
                <div className='divTimeline'>
                    <M_TimeLine valueTimeline={valueTimeline} />
                </div>
            </div>
            <div className='divBaseBooking'>
                <div className='divButtonSubmitBooking'>
                    <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ margin: '0' }}>Booking Number: &nbsp; </h4><h2 style={{ margin: '0' }}> {extraValues.get('BookingNumber')}</h2>
                    </div>
                    {extraValues.get('QuoteName') && 
                        <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                            <h4 style={{ margin: '0' }}>Quote Name: &nbsp; </h4><h2 style={{ margin: '0' }}> {extraValues.get('QuoteName')}</h2>
                        </div>
                    }
                </div>
                <div className='menusBooking'>
                    {/* Voyage Card */}
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={voyageDict}
                        setVarNameDict={setVoyageDict}
                        onAfterApply={() => { }}
                    >
                        <M_Fieldset
                            labelInside
                            height='calc(100% - 20px)'
                            label={<span style={{ display: 'flex', alignItems: 'center' }}><DirectionsBoatIcon style={{ marginRight: '5px' }} /> {t("Voyage")}</span>}
                            elements={
                                <div className='divTextfieldVoyage' >
                                    {voyage.map((value, index) => (
                                        <div key={index}>
                                            {value.label === 'Voyage' ?
                                                <div key={index} className='textfield' >
                                                    <M_DrawerTableTextField
                                                        tableLabel={'Transports'}
                                                        label={value.label}
                                                        value={extraValues.get('transport id') ?
                                                            {
                                                                Id: extraValues.get('transport id') || '',
                                                                VoyageNumber: voyageDict.get('Voyage') || '',
                                                                VesselCode: voyageDict.get('Vessel') || '',
                                                            }
                                                            : null}
                                                        entity={'transport'}
                                                        FILTER={"TransportState eq 'Open'"}
                                                        filterField={"VoyageNumber"}
                                                        labelFields={['VesselCode', 'VoyageNumber']}
                                                        onSubmitValue={(obj) => {
                                                            addValue('transport id', obj ? obj['Id'] : '', extraValues, setExtraValues)
                                                            addValue('Voyage', obj ? obj['VoyageNumber'] : '', voyageDict, setVoyageDict)
                                                            addValue('Vessel', obj ? obj['VesselCode'] : '', voyageDict, setVoyageDict)
                                                        }}
                                                        color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                        secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                        favoritesFieldName="Voyage"
                                                        favoritesGroupName="Voyage"
                                                        favoritesIdKey="transport id"
                                                        favoritesVarKey="Voyage"
                                                    />
                                                </div>
                                                :
                                                <div key={index} className='textfield' >
                                                    <M_InputTextField
                                                        label={value.label}
                                                        disabled
                                                        value={voyageDict.get(value.label) || ''}
                                                        color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                        secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    ))}
                                    {isAdmin && (
                                        <div className='textfield'>
                                            <M_InputTextField
                                                label={t('Bound')}
                                                disabled
                                                value={adminDict.get('TradeBound') || ''}
                                            />
                                        </div>
                                    )}
                                    {!matches && <div style={{ height: '62px' }}></div>}
                                </div>
                            }
                        />
                    </M_FormFavorites>

                    {/* Entities Card */}
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={entitiesVarNameDict}
                        setVarNameDict={setEntitiesVarNameDict}
                        onAfterApply={() => { }}
                    >
                        <div style={{ position: 'relative', height: '100%' }}>
                            <GroupFavoriteActions groupName="Entities" t={t} />
                            <M_Fieldset
                                labelInside
                                height='calc(100% - 20px)'
                                label={<span style={{ display: 'flex', alignItems: 'center', }}><GroupIcon style={{ marginRight: '5px' }} /> {t("Entities")}</span>}
                                elements={
                                    <div className='divTextfield'>
                                        {companies?.length > 1 &&
                                            <div className='textfield'>
                                                <M_Select
                                                    autocomplete
                                                    required
                                                    color={!extraValues.get('UserCompanyId') ? 'var(--color-red)' : null}
                                                    secondColor={!extraValues.get('UserCompanyId') ? 'var(--color-red)' : null}
                                                    label={'Company'}
                                                    value={entitiesDict.get('Company') ?
                                                        {
                                                            label: entitiesDict.get('Company'),
                                                            value: extraValues.get('UserCompanyId')
                                                        } : null}
                                                    options={companies?.map((company) => {
                                                        return { label: company.Code, value: company.Id, accountId: company.AccountId }
                                                    })}
                                                    onChangeValue={(obj) => {
                                                        if (obj) {
                                                            addValue('Company', obj.label, entitiesDict, setEntitiesDict)
                                                            addValue('UserCompanyId', obj.value, extraValues, setExtraValues)
                                                            getAccountCompany(obj.accountId)
                                                        } else {
                                                            addValue('Company', '', entitiesDict, setEntitiesDict)
                                                            addValue('UserCompanyId', '', extraValues, setExtraValues)
                                                            getAccountCompany(null)
                                                        }
                                                    }}
                                                    size={'100%'}
                                                    favoritesFieldName="Company"
                                                    favoritesGroupName="Entities"
                                                    favoritesIdKey="UserCompanyId"
                                                    favoritesVarKey="Company"
                                                />
                                            </div>
                                        }
                                        {entities?.map((value, index) => (
                                            <div key={index} className='textfield' >
                                                {value.label === 'Client' ?
                                                    companies?.length == 0 ?
                                                        <M_InputTextField
                                                            label={value.label}
                                                            value={entitiesDict.get(value.code) || ''}
                                                            disabled
                                                            color={changedList.includes('Client Id') ? 'var(--color-yellow)' : null}
                                                            secondColor={changedList.includes('Client Id') ? 'var(--color-yellow)' : null}
                                                            favoritesFieldName="Client"
                                                            favoritesGroupName="Entities"
                                                            favoritesVarKey={value.code}
                                                            favoritesIdKey="Client Id"
                                                        />
                                                        : companies?.length == 1 ?
                                                            <M_InputTextField
                                                                label={value.label}
                                                                value={entitiesDict.get(value.code) || ''}
                                                                disabled
                                                                color={changedList.includes('Client Id') ? 'var(--color-yellow)' : null}
                                                                secondColor={changedList.includes('Client Id') ? 'var(--color-yellow)' : null}
                                                                favoritesFieldName="Client"
                                                                favoritesGroupName="Entities"
                                                                favoritesVarKey={value.code}
                                                                favoritesIdKey="Client Id"
                                                            />
                                                            :
                                                            <>
                                                            {/* <M_Select
                                                                autocomplete
                                                                label={'Company'}
                                                                value={entitiesDict.get('Company') ?
                                                                    {
                                                                        label: entitiesDict.get('Company'),
                                                                        value: entitiesDict.get('UserCompanyId')
                                                                    } : null}
                                                                options={companies?.map((company) => {
                                                                    return { label: company.Code, value: company.Id, accountId: company.AccountId }
                                                                })}
                                                                onChangeValue={(obj) => {
                                                                    if (obj) {
                                                                        console.log(obj)
                                                                        addValue('Company', obj.label, entitiesDict, setEntitiesDict)
                                                                        addValue('UserCompanyId', obj.value, extraValues, setExtraValues)
                                                                        getAccountCompany(obj.accountId)
                                                                    } else {
                                                                        addValue('Company', '', entitiesDict, setEntitiesDict)
                                                                        addValue('UserCompanyId', '', extraValues, setExtraValues)
                                                                        getAccountCompany(null)
                                                                    }
                                                                }}
                                                                // size={'150px'}
                                                                marginRight={'5px'}
                                                            /> */}
                                                                <M_InputTextField
                                                                    label={value.label}
                                                                    value={entitiesDict.get(value.code) || ''}
                                                                    disabled
                                                                    color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                                    secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                                    favoritesFieldName="Client"
                                                                    favoritesGroupName="Entities"
                                                                    favoritesVarKey={value.code}
                                                                    favoritesIdKey="Client Id"
                                                                />
                                                            </>
                                                    :
                                                    value.label === 'Client VAT' ?
                                                        <M_InputTextField
                                                            label={value.label}
                                                            value={entitiesDict.get(value.code) || ''}
                                                            disabled
                                                            color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                            secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                            favoritesFieldName="Client VAT"
                                                            favoritesGroupName="Entities"
                                                            favoritesVarKey={value.code}
                                                        />
                                                        :
                                                        value.code === 'InvoiceCode' ?
                                                            <>
                                                                <M_DrawerTableTextField
                                                                    label={value.label}
                                                                    value={extraValues.get('InvoiceId') ? {
                                                                        Id: extraValues.get('InvoiceId'),
                                                                        AccountCode: entitiesDict.get('InvoiceCode'),
                                                                        AccountVATNumber: entitiesDict.get('InvoiceVat')
                                                                    } : null}
                                                                    filterField={'AccountCode'}
                                                                    entity={'Account'}
                                                                    required={true}
                                                                    labelFields={['AccountCode', 'AccountVATNumber']}
                                                                    tableLabel={'Accounts'}
                                                                    color={changedList.includes(value.id) ? 'var(--color-yellow)' : !entitiesDict.get(value.code) ? 'var(--color-red)' : null}
                                                                    secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : !entitiesDict.get(value.code) ? 'var(--color-red)' : null}
                                                                    onSubmitValue={(obj) => {
                                                                        if (obj) {
                                                                            addValue(`InvoiceId`, obj['Id'] || '', extraValues, setExtraValues)
                                                                            addValue(`InvoiceId`, obj['Id'] || '', entitiesDict, setEntitiesDict)
                                                                            addValue('InvoiceVat', obj['AccountVATNumber'] || '', entitiesDict, setEntitiesDict)
                                                                            addValue('InvoiceCode', obj['AccountCode'] || '', entitiesDict, setEntitiesDict)
                                                                        } else {
                                                                            addValue(`InvoiceId`, '', extraValues, setExtraValues)
                                                                            addValue(`InvoiceId`, '', entitiesDict, setEntitiesDict)
                                                                            addValue('InvoiceVat', '', entitiesDict, setEntitiesDict)
                                                                            addValue('InvoiceCode', '', entitiesDict, setEntitiesDict)
                                                                        }
                                                                    }}
                                                                    favoritesFieldName="Invoice Entity"
                                                                    favoritesGroupName="Entities"
                                                                    favoritesIdKey="InvoiceId"
                                                                    favoritesVarKey="InvoiceCode"
                                                                />
                                                            </>
                                                            : value.code === 'InvoiceVat' ?
                                                                <M_InputTextField
                                                                    passRequired={true}
                                                                    label={value.label}
                                                                    value={entitiesDict.get(value.code) || ''}
                                                                    disabled
                                                                    onChange={(e) => { }}
                                                                    secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : !entitiesDict.get(value.code) ? 'var(--color-red)' : null}
                                                                    color={changedList.includes(value.id) ? 'var(--color-yellow)' : !entitiesDict.get(value.code) ? 'var(--color-red)' : null}
                                                                    favoritesFieldName="Invoice VAT"
                                                                    favoritesGroupName="Entities"
                                                                    favoritesVarKey={value.code}
                                                                />
                                                                :
                                                                <M_InputTextField
                                                                    label={value.label}
                                                                    value={entitiesDict.get(value.code) || ''}
                                                                    onChange={(e) => addValue(value.code, e.target.value, entitiesDict, setEntitiesDict)}
                                                                    color={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                                    secondColor={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                                    favoritesFieldName={value.label}
                                                                    favoritesGroupName="Entities"
                                                                    favoritesVarKey={value.code}
                                                                />
                                                }
                                            </div>
                                        ))}
                                        {isAdmin && (
                                            <>
                                                {[
                                                    { label: t('SubAccount'), idKey: 'SubAccountId', codeKey: 'SubAccountCode' },
                                                    { label: t('Shipper'), idKey: 'ShipperId', codeKey: 'ShipperCode' },
                                                    { label: t('Consignee'), idKey: 'ConsigneeId', codeKey: 'ConsigneeCode' },
                                                    { label: t('Notify'), idKey: 'NotifyId', codeKey: 'NotifyCode' },
                                                    { label: t('Agent'), idKey: 'AgentId', codeKey: 'AgentCode' },
                                                    { label: t('ExtLineCode'), idKey: 'ExternalLineId', codeKey: 'ExternalLineCode' },
                                                ].map((field) => (
                                                    <div key={field.idKey} className='textfield'>
                                                        <M_DrawerTableTextField
                                                            label={field.label}
                                                            value={adminDict.get(field.idKey) ? {
                                                                Id: adminDict.get(field.idKey),
                                                                AccountCode: adminDict.get(field.codeKey) || '',
                                                            } : null}
                                                            entity={'Account'}
                                                            filterField={'AccountCode'}
                                                            labelFields={['AccountCode']}
                                                            tableLabel={'Accounts'}
                                                            onSubmitValue={(obj) => {
                                                                if (!setAdminDict) return
                                                                setAdminDict(prev => {
                                                                    const next = new Map(prev)
                                                                    next.set(field.idKey, obj ? obj['Id'] : null)
                                                                    next.set(field.codeKey, obj ? obj['AccountCode'] : '')
                                                                    return next
                                                                })
                                                                addValue(field.codeKey, obj ? obj['AccountCode'] : '', entitiesDict, setEntitiesDict)
                                                                addValue(field.idKey, obj ? obj['Id'] : null, extraValues, setExtraValues)
                                                            }}
                                                            color={changedList.includes(field.idKey) ? 'var(--color-yellow)' : null}
                                                            secondColor={changedList.includes(field.idKey) ? 'var(--color-yellow)' : null}
                                                            favoritesFieldName={field.label}
                                                            favoritesGroupName="Entities"
                                                            favoritesIdKey={field.idKey}
                                                            favoritesVarKey={field.codeKey}
                                                        />
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    </div>
                                }
                            />
                        </div>
                    </M_FormFavorites>

                    {/* Ports Card */}
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={portsVarNameDict}
                        setVarNameDict={setPortsVarNameDict}
                        onAfterApply={() => { }}
                    >
                        <div style={{ position: 'relative', height: '100%' }}>
                            <GroupFavoriteActions groupName="Ports" t={t} />
                            <M_Fieldset
                                labelInside
                                height='calc(100% - 20px)'
                                label={<span style={{ display: 'flex', alignItems: 'center', }}><Anchor style={{ marginRight: '5px' }} /> {t("Ports")}</span>}
                                elements={
                                    <div className='divTextfield'>
                                        {isAdmin && (
                                            <div className='textfield'>
                                                <M_DrawerTableTextField
                                                    label={t('PreCarriage')}
                                                    value={adminDict.get('PreCarriageId') ? {
                                                        Id: adminDict.get('PreCarriageId'),
                                                        LocationName: adminDict.get('PreCarriageName') || '',
                                                    } : null}
                                                    entity={'location'}
                                                    filterField={'LocationName'}
                                                    labelFields={['LocationName']}
                                                    tableLabel={'Locations'}
                                                    FILTER={'LocationPortStatus eq true'}
                                                    onSubmitValue={(obj) => {
                                                        if (!setAdminDict) return
                                                        setAdminDict(prev => {
                                                            const next = new Map(prev)
                                                            next.set('PreCarriageId', obj ? obj['Id'] : null)
                                                            next.set('PreCarriageName', obj ? obj['LocationName'] : '')
                                                            return next
                                                        })
                                                        addValue('Pre Carriage', obj ? obj['LocationName'] : '', locationsDict, setLocationsDict)
                                                        addValue('Pre Carriage id', obj ? obj['Id'] : '', extraValues, setExtraValues)
                                                    }}
                                                    color={changedList.includes('PreCarriagePortId') ? 'var(--color-yellow)' : null}
                                                    secondColor={changedList.includes('PreCarriagePortId') ? 'var(--color-yellow)' : null}
                                                    favoritesFieldName="Pre Carriage"
                                                    favoritesGroupName="Ports"
                                                    favoritesIdKey="Pre Carriage id"
                                                    favoritesVarKey="Pre Carriage"
                                                />
                                            </div>
                                        )}
                                        {portsLocations.filter(obj => obj?.show && obj.type !== 'checkbox').map((value, index) => (
                                            <div key={index} className='textfield'>
                                                <M_DrawerTableTextField
                                                    label={value.label}
                                                    value={extraValues.get(`${value.label} id`) ? {
                                                        Id: extraValues.get(`${value.label} id`),
                                                        LocationName: locationsDict.get(value.label)
                                                    } : null}
                                                    entity={'location'}
                                                    tableLabel={'Locations'}
                                                    required={value.name === 'LocationLoadingPortName' || value.name === 'LocationDischargePortName' ? true : false}
                                                    color={changedList.includes(value.id) ? 'var(--color-yellow)' : (value.name === 'LocationLoadingPortName' || value.name === 'LocationDischargePortName') && !locationsDict.get(value.label) ? 'var(--color-red)' : null}
                                                    secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : (value.name === 'LocationLoadingPortName' || value.name === 'LocationDischargePortName') && !locationsDict.get(value.label) ? 'var(--color-red)' : null}
                                                    FILTER={'LocationPortStatus eq true'}
                                                    filterField={'LocationName'}
                                                    labelFields={['LocationName']}
                                                    onSubmitValue={(obj) => {
                                                        addValue(value.label + ' ' + 'Code', obj ? obj['LocationCode'] : '', locationsDict, setLocationsDict)
                                                        addValue(value.label, obj ? obj['LocationName'] : '', locationsDict, setLocationsDict)
                                                        addValue(`${value.label} id`, obj ? obj['Id'] : '', extraValues, setExtraValues)
                                                    }}
                                                    favoritesFieldName={value.label}
                                                    favoritesGroupName="Ports"
                                                    favoritesIdKey={`${value.label} id`}
                                                    favoritesVarKey={value.label}
                                                />
                                            </div>
                                        ))}
                                        {isAdmin && (
                                            <div className='textfield'>
                                                <M_DrawerTableTextField
                                                    label={t('OnCarriage')}
                                                    value={adminDict.get('OnCarriageId') ? {
                                                        Id: adminDict.get('OnCarriageId'),
                                                        LocationName: adminDict.get('OnCarriageName') || '',
                                                    } : null}
                                                    entity={'location'}
                                                    filterField={'LocationName'}
                                                    labelFields={['LocationName']}
                                                    tableLabel={'Locations'}
                                                    FILTER={'LocationPortStatus eq true'}
                                                    onSubmitValue={(obj) => {
                                                        if (!setAdminDict) return
                                                        setAdminDict(prev => {
                                                            const next = new Map(prev)
                                                            next.set('OnCarriageId', obj ? obj['Id'] : null)
                                                            next.set('OnCarriageName', obj ? obj['LocationName'] : '')
                                                            return next
                                                        })
                                                        addValue('On Carriage', obj ? obj['LocationName'] : '', locationsDict, setLocationsDict)
                                                        addValue('On Carriage id', obj ? obj['Id'] : '', extraValues, setExtraValues)
                                                    }}
                                                    color={changedList.includes('OnCarriagePortId') ? 'var(--color-yellow)' : null}
                                                    secondColor={changedList.includes('OnCarriagePortId') ? 'var(--color-yellow)' : null}
                                                    favoritesFieldName="On Carriage"
                                                    favoritesGroupName="Ports"
                                                    favoritesIdKey="On Carriage id"
                                                    favoritesVarKey="On Carriage"
                                                />
                                            </div>
                                        )}
                                        {portsLocations.filter(obj => obj?.show && obj.type === 'checkbox').map((value, index) => (
                                            <div className='checkbox textfield paddingLeft' key={`chk-${index}`}>
                                                {value.label === "Transhipment" ?
                                                    <M_CheckBox
                                                        checked={locationsDict.get(value.label) || false}
                                                        label={value.label}
                                                        color={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                    /> : <M_CheckBox />
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                            />
                        </div>
                    </M_FormFavorites>
                </div>
            </div>

            {/* Second Process — Admin only */}
            {isAdmin && (
                <div className='divForm'>
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={processDetailsDict}
                        setVarNameDict={setProcessDetailsDict}
                        onAfterApply={() => { }}
                    >
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center' }}><AirlineStopsOutlined style={{ marginRight: '5px' }} /> {t('SecondProcess')}</span>}
                        elements={
                            <div className='divTextfield'>
                                <div className='textfield'>
                                    <M_DrawerTableTextField
                                        tableLabel={'Transports'}
                                        label={t('SVoyage')}
                                        value={adminDict.get('SecondTransportId') ? {
                                            Id: adminDict.get('SecondTransportId'),
                                            VoyageNumber: adminDict.get('SecondVoyageNumber') || '',
                                            VesselCode: adminDict.get('SecondVesselCode') || '',
                                        } : null}
                                        entity={'transport'}
                                        filterField={'VoyageNumber'}
                                        labelFields={['VesselCode', 'VoyageNumber']}
                                        onSubmitValue={(obj) => {
                                            if (!setAdminDict) return
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('SecondTransportId', obj ? obj['Id'] : null)
                                                next.set('SecondVoyageNumber', obj ? obj['VoyageNumber'] : '')
                                                next.set('SecondVesselCode', obj ? obj['VesselCode'] : '')
                                                if (!obj) {
                                                    next.set('SecondTradeCode', '')
                                                    next.set('SecondTradeLineCode', '')
                                                    next.set('SecondTradeBound', '')
                                                }
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        favoritesFieldName={t('SVoyage')}
                                        favoritesGroupName="SecondProcess"
                                        favoritesIdKey="SecondTransportId"
                                        favoritesVarKey="SecondVoyageNumber"
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField label={t('SVesselCode')} disabled value={adminDict.get('SecondVesselCode') || ''}
                                        color={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField label={t('SLineCode')} disabled value={adminDict.get('SecondTradeLineCode') || ''}
                                        color={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField label={t('SServiceCode')} disabled value={adminDict.get('SecondTradeCode') || ''}
                                        color={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField label={t('TradeName')} disabled value={adminDict.get('SecondTradeName') || ''}
                                        color={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField label={t('SBound')} disabled value={adminDict.get('SecondTradeBound') || ''}
                                        color={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('SecondTransportId') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                            </div>
                        }
                    />
                    </M_FormFavorites>
                </div>
            )}

            {/* Process Details — Admin only */}
            {isAdmin && (
                <div className='divForm'>
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={processDetailsDict}
                        setVarNameDict={setProcessDetailsDict}
                        onAfterApply={() => { }}
                    >
                    <div style={{ position: 'relative' }}>
                        <GroupFavoriteActions groupName="ProcessDetails" t={t} />
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center' }}><RequestQuoteOutlined style={{ marginRight: '5px' }} /> {t('ProcessDetails')}</span>}
                        elements={
                            <div className='divTextfield'>
                                <div className='textfield'>
                                    <M_InputTextField
                                        label={t('BLNumber')}
                                        disabled
                                        value={adminDict.get('BLNumber') || ''}
                                        color={changedList.includes('BLNumber') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('BLNumber') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_DrawerTableTextField
                                        label={t('ShippingCode')}
                                        value={adminDict.get('ShippingConditionId') ? {
                                            Id: adminDict.get('ShippingConditionId'),
                                            ShippingConditionCode: adminDict.get('ShippingConditionCode') || '',
                                        } : null}
                                        entity={'ShippingCondition'}
                                        useGet
                                        filterField={'ShippingConditionCode'}
                                        labelFields={['ShippingConditionCode']}
                                        tableLabel={'Shipping Conditions'}
                                        onSubmitValue={(obj) => {
                                            if (!setAdminDict) return
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('ShippingConditionId', obj ? obj['Id'] : null)
                                                next.set('ShippingConditionCode', obj ? obj['ShippingConditionCode'] : '')
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('ShippingConditionId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('ShippingConditionId') ? 'var(--color-yellow)' : null}
                                        favoritesFieldName={t('ShippingCode')}
                                        favoritesGroupName="ProcessDetails"
                                        favoritesIdKey="ShippingConditionId"
                                        favoritesVarKey="ShippingConditionCode"
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField
                                        label={t('MRN')}
                                        value={adminDict.get('Mrn') || ''}
                                        onChange={(e) => {
                                            if (!setAdminDict) return
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('Mrn', e.target.value)
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('Mrn') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('Mrn') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_DrawerTableTextField
                                        label={t('Currency')}
                                        value={adminDict.get('CurrencyId') ? {
                                            Id: adminDict.get('CurrencyId'),
                                            Code: adminDict.get('CurrencyCode') || '',
                                        } : null}
                                        entity={'Currency'}
                                        filterField={'Code'}
                                        labelFields={['Code']}
                                        tableLabel={'Currencies'}
                                        onSubmitValue={(obj) => {
                                            if (!setAdminDict) return
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('CurrencyId', obj ? obj['Id'] : null)
                                                next.set('CurrencyCode', obj ? obj['Code'] : '')
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('CurrencyId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('CurrencyId') ? 'var(--color-yellow)' : null}
                                        favoritesFieldName={t('Currency')}
                                        favoritesGroupName="ProcessDetails"
                                        favoritesIdKey="CurrencyId"
                                        favoritesVarKey="CurrencyCode"
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_InputTextField
                                        label={t('NrDocs')}
                                        type='number'
                                        value={adminDict.get('DocumentQuantity') ?? ''}
                                        onChange={(e) => {
                                            if (!setAdminDict) return
                                            const val = parseInt(e.target.value, 10)
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('DocumentQuantity', isNaN(val) ? null : Math.min(val, 9999999))
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('DocumentQuantity') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('DocumentQuantity') ? 'var(--color-yellow)' : null}
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_DrawerTableTextField
                                        label={t('Incoterms')}
                                        value={adminDict.get('IncotermsId') ? {
                                            Id: adminDict.get('IncotermsId'),
                                            Code: adminDict.get('IncotermsCode') || '',
                                        } : null}
                                        entity={'Incoterms'}
                                        useGet
                                        filterField={'Code'}
                                        labelFields={['Code']}
                                        tableLabel={'Incoterms'}
                                        onSubmitValue={(obj) => {
                                            if (!setAdminDict) return
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('IncotermsId', obj ? obj['Id'] : null)
                                                next.set('IncotermsCode', obj ? obj['Code'] : '')
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('IncotermsId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('IncotermsId') ? 'var(--color-yellow)' : null}
                                        favoritesFieldName={t('Incoterms')}
                                        favoritesGroupName="ProcessDetails"
                                        favoritesIdKey="IncotermsId"
                                        favoritesVarKey="IncotermsCode"
                                    />
                                </div>
                                <div className='textfield'>
                                    <M_DrawerTableTextField
                                        label={t('CStatusCode')}
                                        value={adminDict.get('CustomStatusId') ? {
                                            Id: adminDict.get('CustomStatusId'),
                                            CustomStatusCode: adminDict.get('CustomStatusCode') || '',
                                        } : null}
                                        entity={'customStatus'}
                                        useGet
                                        filterField={'CustomStatusCode'}
                                        labelFields={['CustomStatusCode']}
                                        tableLabel={'Custom Status'}
                                        onSubmitValue={(obj) => {
                                            if (!setAdminDict) return
                                            setAdminDict(prev => {
                                                const next = new Map(prev)
                                                next.set('CustomStatusId', obj ? obj['Id'] : null)
                                                next.set('CustomStatusCode', obj ? obj['CustomStatusCode'] : '')
                                                return next
                                            })
                                        }}
                                        color={changedList.includes('CustomStatusId') ? 'var(--color-yellow)' : null}
                                        secondColor={changedList.includes('CustomStatusId') ? 'var(--color-yellow)' : null}
                                        favoritesFieldName={t('CStatusCode')}
                                        favoritesGroupName="ProcessDetails"
                                        favoritesIdKey="CustomStatusId"
                                        favoritesVarKey="CustomStatusCode"
                                    />
                                </div>
                            </div>
                        }
                    />
                    </div>
                    </M_FormFavorites>
                </div>
            )}

            {/* Shipments */}
            <div className='divForm'>
                <M_FormFavorites
                    entityName="Bookings"
                    pageUrl="Booking"
                    varNameDict={equipmentDict}
                    setVarNameDict={setEquipmentDict}
                    onAfterApply={() => { }}
                >
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center', }}><AirlineStopsOutlined style={{ marginRight: '5px' }} /> {t("Shipments")}</span>}
                        elements={
                            <>
                                <div className='stickyBaseBase'>
                                    {/* <div className='divTitleEquipments'> {t("Equipments")} </div> */}
                                    <div className='displayGridEquipment'>
                                        {equipments.map((value, index) => (
                                            value.type === "textfield" ?
                                                <div key={index} className='textfield' >
                                                    {value.label === "Load Weight (KG)" ?
                                                        <M_InputTextField
                                                            type={"number"}
                                                            label={value.label}
                                                            value={equipmentDict.get(value.label) || ''}
                                                            onChange={(e) => addValue(value.label, e.target.value, equipmentDict, setEquipmentDict)}
                                                        />
                                                        : value.label === "Quantity" ?
                                                            <M_InputTextField
                                                                type={"number"}
                                                                label={value.label}
                                                                value={equipmentDict.get(value.label) || ''}
                                                                onChange={(e) => addValue(value.label, e.target.value, equipmentDict, setEquipmentDict)}
                                                            /> :
                                                            <M_InputTextField
                                                                label={value.label}
                                                                value={equipmentDict.get(value.label) || ''}
                                                                onChange={(e) => addValue(value.label, e.target.value, equipmentDict, setEquipmentDict)}
                                                            />
                                                    }
                                                </div>
                                                : value.type === "combobox" ?
                                                    <div key={index} className='selectBooking'>
                                                        {value.label === 'Equipment Type' &&
                                                            <M_DrawerTableTextField
                                                                loadOnMount={true}
                                                                tableLabel={'Equipment Types'}
                                                                label={value.label}
                                                                value={equipmentDict.get('EquipmentTypeId') ? {
                                                                    Id: equipmentDict.get('EquipmentTypeId') || '',
                                                                    Code: equipmentDict.get('EquipmentType') || '',
                                                                } : null}
                                                                entity={'EquipmentType'}
                                                                api={'secondary'}
                                                                filterField={'Code'}
                                                                labelFields={['Length', 'Code']}
                                                                onSubmitValue={(obj) => {
                                                                    console.log('=== Shipment EquipmentType selecionado (CC) ===', obj)
                                                                    if (obj) {
                                                                        const typeId = obj?.ExternalId || obj?.Id
                                                                        const code = obj?.Code || ''
                                                                        const length = obj?.Length || ''
                                                                        const classCode = obj?.EquipmentClassCode || ''
                                                                        
                                                                        const newDict = new Map(equipmentDict)
                                                                        newDict.set('EquipmentTypeId', typeId || '')
                                                                        newDict.set('Equipment Type', `${code || ''}`)
                                                                        newDict.set('EquipmentType', code)
                                                                        newDict.set('EquipmentClassCode', classCode)
                                                                        setEquipmentDict(newDict)
                                                                    } else {
                                                                        const newDict = new Map(equipmentDict)
                                                                        newDict.set('EquipmentTypeId', '')
                                                                        newDict.set('Equipment Type', '')
                                                                        newDict.set('EquipmentType', '')
                                                                        newDict.set('EquipmentClassCode', '')
                                                                        setEquipmentDict(newDict)
                                                                    }
                                                                }}
                                                                favoritesFieldName="Equipment Type"
                                                                favoritesGroupName="Equipments"
                                                                favoritesIdKey="EquipmentTypeId"
                                                                favoritesVarKey="EquipmentType"
                                                            />
                                                        }
                                                        {value.label === 'Shipment' &&
                                                            <M_Select
                                                                label={value.label}
                                                                value={equipmentDict.get(value.label) || ''}
                                                                onChange={(e) => addValue(value.label, e.target.value, equipmentDict, setEquipmentDict)}
                                                                options={shipmentArray.map(shipments => {
                                                                    return { label: `Shipment ${shipments}`, value: shipments }
                                                                })}
                                                            />
                                                        }
                                                    </div>
                                                    : value.type === "date" ?
                                                        <div key={index} className='textfield' >
                                                            <M_InputTextField
                                                                value={equipmentDict.get(value.label) || ''}
                                                                type='date'
                                                                label={value.label}
                                                                onChange={(e) => addValue(value.label, e.target.value, equipmentDict, setEquipmentDict)}
                                                            />
                                                        </div>
                                                        : value.type === "checkbox" ?
                                                            value.code === 'Reefer' || value.code === 'OpenTop' || value.code === 'RORO' ?
                                                                <div className='checkbox' key={index}>
                                                                    <M_CheckBox
                                                                        checked={equipmentDict.get(value.code) || false}
                                                                        disabled={true}
                                                                        label={value.label}
                                                                    />
                                                                </div>
                                                                :
                                                                <div className='checkbox' key={index}>
                                                                    <M_CheckBox
                                                                        onChange={(e) => addValue(value.code, e.target.checked, equipmentDict, setEquipmentDict)}
                                                                        checked={equipmentDict.get(value.code) || false}
                                                                        label={value.label}
                                                                    />
                                                                </div>
                                                            :
                                                            ""
                                        ))}
                                    </div>
                                    <div className='divButtonSubmitBooking'>
                                        <div></div>
                                        <M_Button
                                            hoverEffect
                                            normal
                                            label={t("Add Shipment")}
                                            icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("AddShipment")} style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)' }} className='iconCreateBooking' />}
                                            tooltip={t("AddShipment")}
                                            onClick={() => addShipment()}
                                            borderColor={'var(--color-grey)'}
                                            bold
                                        />
                                    </div>
                                </div>
                                {useMemo(() => <TableEquipments
                                    value={shipmentObjArray}
                                    setValue={setShipmentObjArray}
                                    shipmentArray={shipmentArray}
                                    setShipmentArray={setShipmentArray}
                                    fillFields={onFillFields}
                                    shipmentIndex={shipmentIndex}
                                    setShipmentIndex={setShipmentIndex}
                                    containerIndex={containerIndex}
                                    setContainerIndex={setContainerIndex}
                                    openDrawer={openDrawer}
                                    setOpenDrawer={setOpenDrawer}
                                    selectedLine={selectedLine}
                                    setSelectedLine={setSelectedLine}
                                    extraValuesArray={extraValues}
                                    toastMessages={toastMessages}
                                    EquipmentIndex={EquipmentIndex}
                                    setEquipmentIndex={setEquipmentIndex}
                                    drawerName={drawerName}
                                    setDrawerName={setDrawerName}
                                    setEquipmentClass={setEquipmentClass}
                                    bookingLine={bookingLine}
                                    draft={draft}
                                    id={id}
                                    fieldsInDrawerEquipment={fieldsInDrawerEquipment}
                                    fieldsInDrawerShipment={fieldsInDrawerShipment}
                                />, [shipmentObjArray,
                                    setShipmentObjArray,
                                    shipmentArray,
                                    setShipmentArray,
                                    onFillFields,
                                    shipmentIndex,
                                    setShipmentIndex,
                                    containerIndex,
                                    setContainerIndex,
                                    openDrawer,
                                    setOpenDrawer,
                                    selectedLine,
                                    setSelectedLine,
                                    extraValues,
                                    toastMessages,
                                    EquipmentIndex,
                                    setEquipmentIndex,
                                    drawerName,
                                    setDrawerName,
                                    setEquipmentClass,
                                    bookingLine,
                                    draft,
                                    id,
                                    fieldsInDrawerEquipment,
                                    fieldsInDrawerShipment,])}
                            </>
                        }
                    />
                </M_FormFavorites>
            </div>

           {/* BookingEquipments */}
            <div className='divForm'>
                <M_FormFavorites
                    entityName="Bookings"
                    pageUrl="Booking"
                    varNameDict={bookingEquipmentDict}
                    setVarNameDict={setBookingEquipmentDict}
                    onAfterApply={() => { }}
                >
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center', }}><i className="pi pi-box" style={{ marginRight: '10px' }}></i>  {t("Equipments")}</span>}
                        elements={
                            <>
                                <div className='stickyBaseBase'>
                                    <div className='displayGridEquipment'>
                                        {bookingEquipments.map((value, index) => {
                                            // TEXTFIELD
                                            if (value.type === "textfield") {
                                                return (
                                                    <div key={index} className='textfield'>
                                                        <M_InputTextField
                                                            label={value.label}
                                                            value={bookingEquipmentDict.get(value.code) || ''}
                                                            onChange={(e) => addValue(value.code, e.target.value, bookingEquipmentDict, setBookingEquipmentDict)}
                                                        />
                                                    </div>
                                                )
                                            }
                                            // COMBOBOX
                                            else if (value.type === "combobox") {
                                                return (
                                                    <div key={index} className='selectBooking'>
                                                        {value.label === 'Shipment' && (
                                                            <M_Select
                                                                label={value.label}
                                                                value={bookingEquipmentDict.get(value.code) || ''}
                                                                onChange={(e) => {
                                                                    const selectedShipment = e.target.value;
                                                                    const newDict = new Map(bookingEquipmentDict);
                                                                    newDict.set(value.code, selectedShipment);
                                                                    
                                                                    if (selectedShipment) {
                                                                        const shipmentItem = shipmentObjArray.find(
                                                                            item => item.Shipment === selectedShipment && item.Equipment !== 'no'
                                                                        );
                                                                        
                                                                        if (shipmentItem && shipmentItem.EquipmentTypeId) {
                                                                            // Fills EquipmentType
                                                                            newDict.set('EquipmentTypeId', shipmentItem.EquipmentTypeId);
                                                                            newDict.set('EquipmentTypeCode', shipmentItem.EquipmentTypeCode || shipmentItem['Equipment Type'] || '');
                                                                            newDict.set('EquipmentTypeLenght', shipmentItem.EquipmentTypeLenght || '');
                                                                            newDict.set('EquipmentType', shipmentItem['Equipment Type'] || '');
                                                                            
                                                                            const externalId = shipmentItem.EquipmentTypeId;
                                                                            containerEquipmentTypeService
                                                                                .filter(`/byExternalId/${externalId}`)
                                                                                .then(response => {
                                                                                    const ccType = Array.isArray(response) ? response[0] : response;
                                                                                    if (ccType && ccType.name !== 'AxiosError') {
                                                                                        const internalId = ccType.Id;
                                                                                        setBookingEquipmentDict(prev => {
                                                                                            const updated = new Map(prev);
                                                                                            updated.set('_equipmentTypeInternalId', internalId);
                                                                                            return updated;
                                                                                        });
                                                                                        console.log('ID interno do EquipmentType:', internalId);
                                                                                    }
                                                                                })
                                                                                .catch(err => console.warn('Erro ao buscar ID interno:', err));
                                                                        }
                                                                    }
                                                                    
                                                                    newDict.set('EquipmentId', '');
                                                                    newDict.set('EquipmentNumber', '');
                                                                    newDict.set('Prefix', '');
                                                                    newDict.set('Number', '');
                                                                    newDict.set('CheckDigit', '');
                                                                    
                                                                    setBookingEquipmentDict(newDict);
                                                                }}
                                                                options={shipmentArray.map(shipments => {
                                                                    return { label: `Shipment ${shipments}`, value: shipments }
                                                                })}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            }
                                            // DATE
                                            else if (value.type === "date") {
                                                return (
                                                    <div key={index} className='textfield'>
                                                        <M_InputTextField
                                                            value={bookingEquipmentDict.get(value.code) || ''}
                                                            type='date'
                                                            label={value.label}
                                                            onChange={(e) => addValue(value.code, e.target.value, bookingEquipmentDict, setBookingEquipmentDict)}
                                                        />
                                                    </div>
                                                )
                                            }
                                            // FOREIGN KEY EQUIPMENT
                                            else if (value.type === "foreignKeyEquipment") {
                                                const internalId = bookingEquipmentDict.get('_equipmentTypeInternalId');
                                                const equipmentId = bookingEquipmentDict.get('EquipmentId');
                                                const equipmentNumber = bookingEquipmentDict.get('EquipmentNumber');
                                                
                                                return (
                                                    <div key={index} className='textfield'>
                                                        <M_DrawerTableTextField
                                                            label={value.label}
                                                            value={equipmentId ? {
                                                                Id: equipmentId,
                                                                EquipmentNumber: equipmentNumber || '',
                                                                Prefix: bookingEquipmentDict.get('Prefix') || '',
                                                                Number: bookingEquipmentDict.get('Number') || '',
                                                                CheckDigit: bookingEquipmentDict.get('CheckDigit') || ''
                                                            } : null}
                                                            entity={value.entity}
                                                            api={value.api}
                                                            tableLabel={value.label}
                                                            filterField={'Prefix'}
                                                            labelFields={['EquipmentNumber', 'Prefix', 'Number', 'CheckDigit']}
                                                            FILTER={internalId ? `EquipmentTypeId eq ${internalId}` : ''}
                                                            onSubmitValue={(obj) => {
                                                                console.log('=== Equipment selecionado ===', obj)
                                                                if (obj) {
                                                                    const eqId = obj?.ExternalId || obj?.Id
                                                                    const pref = obj?.Prefix || ''
                                                                    const num = obj?.Number || ''
                                                                    const cd = obj?.CheckDigit || ''
                                                                    const equipNum = `${pref} ${num} ${cd}`.trim()
                                                                    
                                                                    const newDict = new Map(bookingEquipmentDict)
                                                                    newDict.set('EquipmentId', eqId || '')
                                                                    newDict.set('EquipmentNumber', equipNum)
                                                                    newDict.set('Prefix', pref)
                                                                    newDict.set('Number', num)
                                                                    newDict.set('CheckDigit', cd)
                                                                    setBookingEquipmentDict(newDict)
                                                                } else {
                                                                    const newDict = new Map(bookingEquipmentDict)
                                                                    newDict.set('EquipmentId', '')
                                                                    newDict.set('EquipmentNumber', '')
                                                                    newDict.set('Prefix', '')
                                                                    newDict.set('Number', '')
                                                                    newDict.set('CheckDigit', '')
                                                                    setBookingEquipmentDict(newDict)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            // FOREIGN KEY (ParkCode, Terminal Loading Code, Terminal Discharge Code)
                                            else if (value.type === "foreignKey") {
                                                return (
                                                    <div key={index} className='textfield'>
                                                        <M_DrawerTableTextField
                                                            label={value.label}
                                                            value={bookingEquipmentDict.get(`${value.code}Id`) ? {
                                                                Id: bookingEquipmentDict.get(`${value.code}Id`),
                                                                LocationName: bookingEquipmentDict.get(value.code) || '',
                                                                LocationCode: bookingEquipmentDict.get(`${value.code}Code`) || ''
                                                            } : null}
                                                            entity={value.entity}
                                                            tableLabel={value.label}
                                                            filterField={value.filterField}
                                                            labelFields={value.labelFields}
                                                            onSubmitValue={(obj) => {
                                                                //console.log(`=== ${value.label} selected ===`, obj)
                                                                if (obj) {
                                                                    const newDict = new Map(bookingEquipmentDict)
                                                                    const locCode = obj['LocationCode'] || obj['locationCode'] || ''
                                                                    const locName = obj['LocationName'] || obj['locationName'] || ''
                                                                    const locId = obj['Id'] || obj['id'] || ''
                                                                    newDict.set(value.code, locCode || locName)
                                                                    newDict.set(`${value.code}Id`, locId)
                                                                    newDict.set(`${value.code}Code`, locCode)
                                                                    setBookingEquipmentDict(newDict)
                                                                } else {
                                                                    const newDict = new Map(bookingEquipmentDict)
                                                                    newDict.set(value.code, '')
                                                                    newDict.set(`${value.code}Id`, '')
                                                                    newDict.set(`${value.code}Code`, '')
                                                                    setBookingEquipmentDict(newDict)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            return null
                                        })}
                                    </div>
                                    <div className='divButtonSubmitBooking'>
                                        <div></div>
                                        <M_Button
                                            hoverEffect
                                            normal
                                            label={t("Add Booking Equipment")}
                                            icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("AddEquip")} style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)' }} className='iconCreateBooking' />}
                                            tooltip={t("AddBookingEquipment")}
                                            onClick={() => addBookingEquipments()}
                                            borderColor={'var(--color-grey)'}
                                            bold
                                        />
                                    </div>
                                </div>
                                {useMemo(() => <TableBookingEquipments
                                    value={bookingEquipmentArray}
                                    setValue={setBookingEquipmentArray}
                                    fillFields={onFillFields}
                                    containerIndex={containerIndex}
                                    setContainerIndex={setContainerIndex}
                                    openDrawer={openDrawer}
                                    setOpenDrawer={setOpenDrawer}
                                    selectedLine={selectedLine}
                                    setSelectedLine={setSelectedLine}
                                    extraValuesArray={extraValues}
                                    toastMessages={toastMessages}
                                    EquipmentIndex={EquipmentIndex}
                                    setEquipmentIndex={setEquipmentIndex}
                                    drawerName={drawerName}
                                    setDrawerName={setDrawerName}
                                    bookingLine={bookingLine}
                                    draft={draft}
                                    id={id}
                                    fieldsInDrawerBookingEquipment={fieldsInDrawerEquipment}
                                    isForSplit={false}
                                />, [bookingEquipmentArray,
                                    setBookingEquipmentArray,
                                    onFillFields,
                                    containerIndex,
                                    setContainerIndex,
                                    openDrawer,
                                    setOpenDrawer,
                                    selectedLine,
                                    setSelectedLine,
                                    extraValues,
                                    toastMessages,
                                    EquipmentIndex,
                                    setEquipmentIndex,
                                    drawerName,
                                    setDrawerName,
                                    bookingLine,
                                    draft,
                                    id,
                                    fieldsInDrawerEquipment])}  
                            </>
                        }
                    />
                </M_FormFavorites>
            </div>

            {/* ShipmentCharges — apenas Admin */}
            {isAdmin && (
                <div className='divForm'>
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center' }}><RequestQuoteOutlined style={{ marginRight: '10px' }} /> {t("ShipmentCharges")}</span>}
                        elements={
                            <TableShipmentCharges
                                value={shipmentChargesArray}
                                shipments={availableShipments}
                                onOpenCreate={availableShipments.length > 0 ? handleOpenCreate : undefined}
                                onOpenEdit={handleOpenEdit}
                                onRefresh={onRefreshCharges}
                            />
                        }
                    />
                </div>
            )}

            <br /> <br /> <br /> <br /> <br />

            <M_MessageBoard
                open={openConfirmModal}
                minWidth={'30%'}
                onClose={handleCloseConfirmModal}
                title={saveAs === 'Draft' ? t("LabelSaveAsDraft") : t("SubButtonBook")}
                body={
                    <span>
                        <span className='modalgrid'>
                            <span className='spanItems'><b>{t("Vessel")}:</b> {voyageDict.get('Vessel')} </span>
                            <span className='spanItems'><b>{t("Voyage")}:</b> {voyageDict.get('Voyage')}  </span>
                            <span className='spanItems'><b>{t("LabelPOD")}:</b> {locationsDict.get('Discharge Port')} </span>
                            <span className='spanItems'><b>{t("LabelPOL")}:</b> {locationsDict.get('Loading Port')} </span>
                            <span className='spanItems'><b>{t("LabelFinalPort")}:</b> {locationsDict.get('Final Port')} </span>
                            <span className='spanItems'><b>{t("LabelClientRef")}:</b> {entitiesDict.get('ClientReference')} </span>
                        </span>
                        <span className='spanItems'><b>{t("Equipments")}:</b>  {summary()} </span>
                        <br />
                        <br />
                        <M_TextArea label={t("Notes")} />
                    </span>
                }
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={handleCloseConfirmModal} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={openConfirmationModal} label={t("ButtonConfirm")} />
                    </span>
                }
            />

            <M_MessageBoard
                open={showChangeQuoteModal}
                minWidth={'30%'}
                onClose={cancelChangeQuote}
                title={t("ChangeQuoteTitle")}
                body={
                    <div style={{ textTransform: 'none' }}>{t("ChangeQuoteWarning")}</div>
                }
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={cancelChangeQuote} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={confirmChangeQuote} label={t("ButtonConfirm")} />
                    </span>
                }
            />

            {/* MODAL SE ERRORS */}
            <M_MessageBoard
                open={OpenModalSeeErrors}
                minWidth={'30%'}
                onClose={() => setOpenModalSeeErrors(false)}
                title={t("ListErrors")}
                body={
                    <span>
                        <b>{errorList.CreatedOn}</b>: {errorList.ErrorMessage}
                    </span>
                }
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setOpenModalSeeErrors(false)} label={t("ButtonCancel")} />
                    </span>
                }
            />

            <M_MessageBoard
                open={confirmationModal}
                onClose={submitedApproval}
                title={saveAs === 'Draft' ? t("InformationSpan") : t("SubButtonBook")}
                body={saveAs === 'Draft' ?
                    <>
                        <span className='modalgrid'>
                            <DoneOutlinedIcon /> <span className='spanItems'> {t("LabelBookSaved")}</span>
                        </span>
                        <br />
                        <br />
                        {extraValues.get('BookingNumber') ? (
                            <>
                                <span className='spanItems'>
                                    <b>{t("LabelBookingNumber")}</b> {extraValues.get('BookingNumber')}
                                </span>
                                <br />
                            </>
                        ) : (
                            <>
                                <span className='spanItems'>
                                    <b>{t("LabelBookingNumberWaitingForTransporter")}</b>
                                </span>
                                <br />
                            </>
                        )}
                        <span className='spanItems'><b>{t("LabelBookingDate")}:</b> {reformatDate(toJSONLocal(new Date()))} </span>
                    </>
                    :
                    <>
                        <span className='modalgrid'>
                            <DoneOutlinedIcon /> <span className='spanItems'> {t("LabelBookSub")}</span>
                        </span>
                        <br />
                        <br />
                        {extraValues.get('BookingNumber') ? (
                            <>
                                <span className='spanItems'>
                                    <b>{t("LabelBookingNumber")}</b> {extraValues.get('BookingNumber')}
                                </span>
                                <br />
                            </>
                        ) : (
                            <>
                                <span className='spanItems'>
                                    <b>{t("LabelBookingNumberWaitingForTransporter")}</b>
                                </span>
                                <br />
                            </>
                        )}
                        <span className='spanItems'><b>{t("LabelBookingDate")}:</b> {reformatDate(toJSONLocal(new Date()))} </span>
                    </>
                }
                footer={<M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={submitedApproval} label={t("ButtonConfirm")} />}
            />

            <M_MessageBoard
                warning
                open={leavingPage}
                onClose={functionLeavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
                    </span>
                }
            />

            <M_ElementDrawer
                open={openEquipmentDrawer}
                setOpen={setOpenEquipmentDrawer}
                onClose={() => setOpenEquipmentDrawer(false)}
                element={
                    <>
                        <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{'Shipments to Move'}</h2>

                        {/*<M_Table
                            entityName={'bookingEquipment'}
                            useSessionStorage={false}
                            crud={false}
                            onPassLine={getLineBooking}
                            tableHeight={'50vh'}
                            selectSingle={false}
                            FILTER={FILTERVGM}
                            extraButtons={[{ label: t("Save"), element: 'default', icon: <i className="pi pi-save iconTable"></i>, command: (e) => setConfirmMovement(true) }]}
                        />*/}
                        {useMemo(() => <TableEquipments
                            onPassLine={getLineBooking}
                            value={shipmentObjArray.filter(function (i) {
                                return i.bookingEquipmentId
                            })}
                            setValue={setShipmentObjArray}
                            shipmentArray={shipmentArray}
                            setShipmentArray={setShipmentArray}
                            fillFields={onFillFields}
                            shipmentIndex={shipmentIndex}
                            setShipmentIndex={setShipmentIndex}
                            containerIndex={containerIndex}
                            setContainerIndex={setContainerIndex}
                            openDrawer={openDrawer}
                            setOpenDrawer={setOpenDrawer}
                            selectedLine={selectedLine}
                            setSelectedLine={setSelectedLine}
                            extraValuesArray={extraValues}
                            toastMessages={toastMessages}
                            EquipmentIndex={EquipmentIndex}
                            setEquipmentIndex={setEquipmentIndex}
                            drawerName={drawerName}
                            setDrawerName={setDrawerName}
                            setEquipmentClass={setEquipmentClass}
                            bookingLine={bookingLine}
                            draft={draft}
                            id={id}
                            fieldsInDrawerEquipment={fieldsInDrawerEquipment}
                            fieldsInDrawerShipment={fieldsInDrawerShipment}
                            isForSplit={true}
                        />, [shipmentObjArray,
                            setShipmentObjArray,
                            shipmentArray,
                            setShipmentArray,
                            onFillFields,
                            shipmentIndex,
                            setShipmentIndex,
                            containerIndex,
                            setContainerIndex,
                            openDrawer,
                            setOpenDrawer,
                            selectedLine,
                            setSelectedLine,
                            extraValues,
                            toastMessages,
                            EquipmentIndex,
                            setEquipmentIndex,
                            drawerName,
                            setDrawerName,
                            setEquipmentClass,
                            bookingLine,
                            draft,
                            id,
                            fieldsInDrawerEquipment,
                            fieldsInDrawerShipment,])}
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Confirm')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setConfirmMovement(true)
                            }}
                        />
                    </>
                }
            />
            <M_MessageBoard
                open={confirmMovement}
                onClose={() => setConfirmMovement(false)}
                title={t('MoveEquipment')}
                body={t("ConfirmEquipmentMoved")}
                footer={(
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Cancel')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setConfirmMovement(false)
                            }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Confirm')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                ctx.setIsLoad(true)
                                onSaveMove()
                            }}
                        />
                    </div>
                )}
            />
            <M_MessageBoard
                open={open}
                onClose={() => setOpen(false)}
                title={t('MoveEquipment')}
                body={t("EquipmentMoved")}
                footer={(
                    <div style={{ display: 'flex' }}>
                        {/*<M_Button
                            normal
                            hoverEffect
                            label={t('CloseTab')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => { continueBooking() }}
                        />*/}
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Continue')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => { continueBooking() }}
                        />
                    </div>
                )}
            />
        </div >
    )
}